export default (queryString) =>
  queryString
    .substring(1)
    .split('&')
    .reduce((params, current) => {
      const [key, value] = current.split('=');
      params[key] = value; // eslint-disable-line security/detect-object-injection
      return params;
    }, {});
